export default "__VITE_ASSET__BHfvp36h__"